import Vue from 'vue';
import App from './App.vue';
import JQuery from 'jquery'; 
import Konva from 'vue-konva';
import Verte from 'verte';
import 'verte/dist/verte.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import { router }  from './router';


Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component('verte', Verte);
Vue.use(Konva);
window.$ = JQuery;
Vue.use(JQuery);
Vue.config.productionTip = true;
new Vue({
    el:'#app',
    router,
    render: h => h(App)
}).$mount('#app');







